import { Box, Button, IconButton } from '@ouster/webviz-react-components';

import { useEffect, useState } from 'react';

import DashboardCard from './DashboardCard';
import userLookupStyle from './userLookup.module.css';

export default function UserLookUpSearch({
  handleSearch,
  clearUserLookup,
}: {
  handleSearch: (email: string) => Promise<void>;
  clearUserLookup: () => void;
}) {
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (email.trim() === '') {
      clearUserLookup();
    }
  }, [email, clearUserLookup]);

  const onSearchHandler = () => {
    if (email.trim()) {
      handleSearch(email.trim());
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onSearchHandler();
    }
  };

  const searchContent = (
    <Box
      display="flex"
      gap={2}
      alignItems="center"
      mt={3}
      data-testid="user-lookup-search-box"
    >
      <Box position="relative" flexGrow={1}>
        <input
          placeholder="Enter email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={handleKeyPress}
          type="email"
          className={userLookupStyle.inputField}
          data-testid="user-lookup-search-input"
        />
        <IconButton
          position="absolute"
          right={1}
          top={1}
          icon="close"
          variant="ghost"
          size="sm"
          emphasis="quiet"
          onClick={() => setEmail('')}
        />
      </Box>
      <Button
        variant="outline"
        onClick={onSearchHandler}
        isDisabled={!email.trim()}
        data-testid="user-lookup-search-button"
      >
        Search
      </Button>
    </Box>
  );

  return (
    <DashboardCard
      title="Search User"
      description="Enter an email address to search for user information"
      data-testid="user-lookup-search-card"
    >
      {searchContent}
    </DashboardCard>
  );
}
